import React, { useEffect, useState } from 'react';
import { useBiLogModalPageView } from '@wix/da-shared-react/pkg/biLogger/hooks/useBiLogModalPageView';
import DeviationDropZonePopup from '../DeviationDropZonePopup';
import DeviationFormPopup from '../DeviationFormPopup';
import { useDispatch } from 'react-redux';
import { splashReady } from '../../redux/actions';

export interface Props {
  deviationId?: number;
  tierId?: number;
  isDraft?: boolean;
  isEdit?: boolean;
  isPageLoadModal?: boolean;
  requestClose: () => void;
}

export const DeviationSubmitPopup: React.FC<Props> = ({
  deviationId: initialDeviationId,
  tierId,
  isDraft,
  isEdit,
  isPageLoadModal,
  requestClose,
}) => {
  const dispatch = useDispatch();
  const [deviationId, setDeviationId] = useState(initialDeviationId);
  const { logPageView } = useBiLogModalPageView({
    component: initialDeviationId
      ? 'form-edit'
      : tierId
      ? 'upload-tier'
      : 'upload-deviation',
    view: 'submit',
  });

  // If deviationId changes it means we got an upload and are moving to form step, so we fire another page view event
  useEffect(() => {
    if (deviationId !== initialDeviationId) {
      logPageView({
        component: tierId ? 'form-tier' : 'form-deviation',
        view: 'submit',
      });
    }
  }, [initialDeviationId, deviationId, tierId, logPageView]);

  useEffect(() => {
    if (!deviationId) {
      dispatch(splashReady());
    }
  }, [deviationId, dispatch]);

  return (
    <>
      {!deviationId && (
        <DeviationDropZonePopup
          requestClose={requestClose}
          tierId={tierId}
          isPageLoadModal={isPageLoadModal}
          onDeviationCreated={setDeviationId}
        />
      )}
      {deviationId && (
        <DeviationFormPopup
          requestClose={requestClose}
          params={{ deviationId, tierId, isDraft, isEdit }}
        />
      )}
    </>
  );
};
DeviationSubmitPopup.displayName = 'DeviationSubmitPopup';

export default DeviationSubmitPopup;
